skyward.base.registerScript("benefitmanagement", function (skyward, $)
{
    skyward.benefitmanagement = skyward.benefitmanagement || {};

    var init = function (selector)
    {
        $(selector + " [name='MaximumDependentCount'], [name='Coverage.MaximumDependentCount']").change(function ()
        {
            var maximumDependentCount = $(this);
            var dependentMessage = $("[name='DependentMessage'], [name='Coverage.DependentMessage']");

            var value = skyward.controls.getValue(maximumDependentCount);

            if (value)
            {
                skyward.controls.setValue(dependentMessage, 'Dependent Count must be less than or equal to ' + value + ' for this Sub-Plan.');
            }
            else
            {
                skyward.controls.setValue(dependentMessage);
            }
        });

    };

    function initEmployeePlanEnrollmentBillDetailCRQETable()
    {
        var $employeePlanEnrollmentBillDetailCRQETable = $(this);

        $employeePlanEnrollmentBillDetailCRQETable.on("change", ".employeePlanEnrollmentBillDetailAmount", { removeAmountOfCurrentRow: false }, recalculateBillDetailAmount);
        $employeePlanEnrollmentBillDetailCRQETable.on("click", ".childrecordquickentryremovebuttoncell", { removeAmountOfCurrentRow: false }, recalculateBillDetailAmount);
        $employeePlanEnrollmentBillDetailCRQETable.on("click", ".childrecordquickentryclearbuttoncell", { removeAmountOfCurrentRow: true }, recalculateBillDetailAmount);
    }

    var recalculateBillDetailAmount = function (event)
    {
        var $employeePlanEnrollmentBillDetailAmounts = $("tr.childrecordquickentryrow").not(".removedElement").find(".employeePlanEnrollmentBillDetailAmount");
        var billDetailAmount = 0;

        if (event.data.removeAmountOfCurrentRow)
        {
            var $amountBeingRemoved = $(this).siblings(".childrecordquickentrycell").children(".employeePlanEnrollmentBillDetailAmount");
            if ($amountBeingRemoved.length > 0)
            {
                var amountBeingRemovedValue = Number($amountBeingRemoved[0].value);
                if (amountBeingRemovedValue)
                {
                    billDetailAmount -= amountBeingRemovedValue;
                }
            }
        }

        for (var i = 0; i < $employeePlanEnrollmentBillDetailAmounts.length; i++)
        {
            var employeePlanEnrollmentBillDetailAmount = Number($employeePlanEnrollmentBillDetailAmounts[i].value);
            if (employeePlanEnrollmentBillDetailAmount)
            {
                billDetailAmount += employeePlanEnrollmentBillDetailAmount;
            }
        }

        var prefix = $(event.currentTarget).getIdAndPrefix().prefix;
        var billDetailAmountControl = $(`#${prefix}BaseCurrencyAmount`);
        var billDetailAmountFormatted = billDetailAmount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        skyward.controls.setValue(billDetailAmountControl, billDetailAmountFormatted);
    };

    skyward.benefitmanagement.buttonActionAndRefresh = function (button)
    {
        const buttonData = $(button).data();
        const objectID = buttonData.objectid;
        const object = buttonData.object;
        const container = buttonData.container;
        const action = buttonData.action;

        $.ajax({
            type: "POST",
            url: `${skyward.global.virtualDir}BenefitManagement/${object}/${action}/${objectID}`,
            success: function (data)
            {
                if (data.success !== null)
                {
                    if (data.success)
                    {
                        window.location.reload();
                    }
                    else
                    {
                        skyward.validation.displayValidationMessages(data, container, $("#CurrentRecordContentBaseError"));
                    }
                }
            }
        });
    };

    skyward.window.registerLoadDOMCallback(init);

    const events =
    {
        "initEmployeePlanEnrollmentBillDetailCRQETable": initEmployeePlanEnrollmentBillDetailCRQETable
    };
    return events;
});